import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'
import { Skeleton } from '@root/shared/ui-kit'

import type { TransKey } from '@root/shared/localization'
import type BigNumber from 'bignumber.js'
type MarketCapVariant = 'normal' | 'short'

type MarketCapProps = {
  variant?: MarketCapVariant
  value: BigNumber
}

const MarketCapVariantTrans = {
  normal: 'pool.mcap',
  short: 'pool.mcap_char',
} satisfies Record<MarketCapVariant, TransKey>

export const MarketCap = (props: MarketCapProps) => {
  const { t } = useTranslation()
  const { variant = 'normal', value } = props

  return (
    <Root>
      <MarketCapTitle>{t(MarketCapVariantTrans[variant])}:</MarketCapTitle>
      <MarketCapValue>
        <Numeric value={value} preset="currency-amount-short" currency="$" />
      </MarketCapValue>
    </Root>
  )
}

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`
export const MarketCapTitle = styled(Typography)`
  color: var(--text-10);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`

export const MarketCapValue = styled(Typography)`
  color: var(--amber-9);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
export const Skeleton_ = (props: { variant?: MarketCapVariant }) => {
  props!
  return (
    <Root>
      <MarketCapTitle>
        <Skeleton.Line
          uppercase
          width={props.variant === 'normal' ? `4ch` : `2ch`}
        />
      </MarketCapTitle>
      <MarketCapValue>
        <Skeleton.Line uppercase width={'5ch'} />
      </MarketCapValue>
    </Root>
  )
}
MarketCap.Skeleton = Skeleton_
